import requests from '@/utils/requests';

/**
 * 上传神策埋点数据接口
 * @param {*} data
 */
export function SensorsUpload (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/tools/SensorsUpload',
    method: 'post',
    data
  });
}
